import React from 'react';
import moment from 'moment';
import {bool, func, string, arrayOf, shape, object, number} from 'prop-types';
import {Modal, Table, Button, Container, Icon} from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';
import lifecycle from 'recompose/lifecycle';
import compose from 'recompose/compose';
import isEmpty from 'lodash/isEmpty';
import partial from 'lodash/partial';
import FieldStatusIcon from 'components/forms/FieldStatusIcon';
import {formatLocalDateTime} from 'utils/DBUtils';
import {RetailerItemPropType} from '../utils';
import PurchaseInfoContent from './PurchaseInfoContent';
import PurchaseInfoPagingBar from './PurchaseInfoPagingBar';

const numPerPage = 25;

const PurchaseInfoModal = compose(
  lifecycle({
    componentWillMount() {
      this.props.getStoreOrders(this.props.retailerItem.id, this.props.year, this.props.month, 25, 1);
    }
  })
)(props => !isEmpty(props.retailerItem) && (
  <Modal
    open={props.isOpen}
    onClose={props.onClose}
    className='primary-modal'
    dimmer='inverted'
    size='small'
    closeIcon>
    <Modal.Header>
      {props.retailerItem.title}
    </Modal.Header>
    <Modal.Content
      scrolling
      className='purchase-info-modal-content'>
      {isEmpty(props.storeOrders) ? (
        <Container textAlign='center'>
          <Icon loading name='spinner' size='big' />
        </Container>
      ) : (
        <Table
          compact='very'
          className='purchase-info-modal-table'>
          <Table.Header className='white-header'>
            <Table.HeaderCell>
              <FormattedMessage id='rewardsStore.modal.purchaseInfo.table.column.userId' />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage id='rewardsStore.modal.purchaseInfo.table.column.fullName' />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage id='rewardsStore.modal.purchaseInfo.table.column.email' />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage id='rewardsStore.modal.purchaseInfo.table.column.ordered' />
            </Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
          </Table.Header>

            <PurchaseInfoContent storeOrders={props.storeOrders}
                                 resendOrderEmail={props.resendOrderEmail}
                                 isInFlightFor={props.isInFlightFor}
                                 resendWasSuccessfulFor={props.resendWasSuccessfulFor}

            />

        </Table>
      )}
      <PurchaseInfoPagingBar retailerItemId={props.retailerItem.id}
                             year={props.year}
                             month={props.month}
                             numPerPage={numPerPage}
      />
    </Modal.Content>
  </Modal>
));

PurchaseInfoModal.propTypes = {
  isOpen: bool,
  onClose: func.isRequired,
  retailerItem: RetailerItemPropType.isRequired,
  getStoreOrders: func.isRequired,
  storeOrders: arrayOf(
    shape({
      id: number.isRequired,
      firstName: string.isRequired,
      lastName: string.isRequired,
      email: string.isRequired,
      purchased: object.isRequired
    })
  ).isRequired,
  resendOrderEmail: func.isRequired
};

PurchaseInfoModal.defaultProps = {
  storeOrders: []
};

export default PurchaseInfoModal;



// WEBPACK FOOTER //
// ./public/pages/Rewards/RewardsTable/PurchaseInfoModal.jsx